// Stroke icons (24px grid, Lucide-style) shared by the shell, dashboard and
// landing page. Usage: <Icon name="sparkles" size={16} />.
const PATHS = {
  grid: "M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z",
  photo: "M4 5h16v14H4zM8.5 10.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM20 15l-5-5L5 19",
  key: "M15.5 7.5a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0zM12 11v10M12 17h3M12 14h2",
  plus: "M12 5v14M5 12h14",
  sparkles:
    "M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9zM19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8zM5 2l.6 1.4L7 4l-1.4.6L5 6l-.6-1.4L3 4l1.4-.6z",
  arrowRight: "M5 12h14M13 6l6 6-6 6",
  check: "M5 12l5 5 9-11",
  code: "M8 7l-5 5 5 5M16 7l5 5-5 5",
  layers: "M12 3l9 5-9 5-9-5zM3 13l9 5 9-5",
  play: "M6 4l14 8-14 8z",
  upload: "M12 16V4M7 9l5-5 5 5M4 16v3a1 1 0 001 1h14a1 1 0 001-1v-3",
  copy: "M9 9h11v11H9zM5 15H4V4h11v1",
  book: "M4 4h6a2 2 0 012 2v14a2 2 0 00-2-2H4zM20 4h-6a2 2 0 00-2 2v14a2 2 0 012-2h6z",
  plug: "M9 2v6M15 2v6M6 8h12v3a6 6 0 01-12 0zM12 17v5",
  table: "M3 5h18v14H3zM3 10h18M3 15h18M9 5v14",
  wand: "M15 4V2M15 10V8M11 6h2M17 6h2M4 20L14 10M13 5l1 1",
  image: "M4 5h16v14H4zM4 15l4-4 4 4 3-3 5 5",
  type: "M5 6V4h14v2M12 4v16M9 20h6",
  bolt: "M13 2L4 14h7l-1 8 9-12h-7z",
  shield: "M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z",
  search: "M11 18a7 7 0 100-14 7 7 0 000 14zM20 20l-4-4",
  chevronDown: "M6 9l6 6 6-6",
  folder: "M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2z",
  x: "M6 6l12 12M18 6L6 18",
  globe: "M12 21a9 9 0 100-18 9 9 0 000 18zM3 12h18M12 3c2.5 2.5 3.5 5.5 3.5 9s-1 6.5-3.5 9c-2.5-2.5-3.5-5.5-3.5-9s1-6.5 3.5-9z",
};

export default function Icon({ name, size = 16, strokeWidth = 2, className, style }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={style}
      aria-hidden="true"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
